<template>
  <div>
    <v-dialog v-model="value" max-width="700" persistent>
      <v-card>
        <v-card-title
          class="
            d-flex
            justify-space-between
            align-center
            primary
            white--text
            py-3
          "
        >
          <span>{{ $t('qr_payment.refund_qr_payment') }}</span>
        </v-card-title>
        <v-card-text class="py-4 px-4" v-if="qrPaymentReport">
          <div class="d-flex justify-space-between total-pay">
            <div>{{ $t('payment.refund_amount') }}</div>
            <div>{{ qrPaymentReport.amount | currencySuffixTextThEn }}</div>
          </div>
          <div class="box-detail mt-4">
            <div class="d-flex justify-space-between my-3">
              <div>{{ $t('bill.customer_market_id') }}</div>
              <div>{{ qrPaymentReport.customerMarketId }}</div>
            </div>
            <div class="d-flex justify-space-between my-3">
              <div>{{ $t('market.marchant_name') }}</div>
              <div>{{ qrPaymentReport.customerData }}</div>
            </div>
            <div class="d-flex justify-space-between my-3">
              <div>{{ $t('area.space') }}</div>
              <div>{{ qrPaymentReport.areasName }}</div>
            </div>
            <div class="d-flex justify-space-between my-3 detail-boder"></div>
            <div class="d-flex justify-space-between my-3">
              <div>
                <div v-if="qrPaymentReport.invoice">{{ $t('bill.document_id') }}</div>
                <div v-else-if="qrPaymentReport.contractCheckout">{{ $t('market.checkout_number') }}</div>
                <div v-else-if="qrPaymentReport.order">{{ $t('payment.order_number') }}</div>
              </div>
              <div>{{ qrPaymentReport.documentId }}</div>
            </div>
            <div class="d-flex justify-space-between my-3">
              <div>{{ $t('status') }}</div>
              <div>
                <template v-if="qrPaymentReport.status == $t('payment.confirmed_payment_success')">
                  <v-chip
                    class="green--text"
                    color="rgb(209,242,225)"
                  >
                    <v-icon left x-small>mdi-circle</v-icon>
                    {{ qrPaymentReport.status }}
                  </v-chip>
                </template>
                <template v-else>
                  <v-chip
                    class="red--text"
                    color="rgb(248,218,218)"
                  >
                    <v-icon left x-small>mdi-circle</v-icon>
                    {{ qrPaymentReport.status }}
                  </v-chip>
                </template>
              </div>
            </div>
            <div class="d-flex justify-space-between my-3 detail-boder"></div>
            <div class="d-flex justify-space-between my-3" v-if="qrPaymentReport.receiptDocumentId && qrPaymentReport.receiptDocumentId != '-'">
              <div>{{ $t('bill.receipt_id') }}</div>
              <div>{{ qrPaymentReport.receiptDocumentId }}</div>
            </div>
            <div class="d-flex justify-space-between my-3" v-if="qrPaymentReport.paymentTimeStamp">
              <div>{{ $t('payment.confirmed_payment_date') }}</div>
              <div>{{ $moment(qrPaymentReport.paymentTimeStamp).format("DD/MM/YYYY") }}, {{ $moment(qrPaymentReport.paymentTimeStamp).format("H:mm") }} {{ $t('timeunit.minute.short') }}</div>
            </div>
  
          </div>
          <div class="mt-4 px-1">
            <div class="mb-3" style="font-size: 16px; color: black;">{{ $t('note') }}</div>
            <v-textarea v-model="note" outlined hide-details rows="2" :placeholder="$t('note')" :disabled="isLoading"></v-textarea>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            @click="dismiss()"
            outlined
            :disabled="isLoading"
          >
            {{ $t('close') }}
          </v-btn>
          <v-btn
            color="primary"
            @click="confirmVoid"
            elevation="0"
            :disabled="isLoading"
            :loading="isLoading"
          >
            {{ $t('confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isResultDialog" max-width="400">
      <v-card v-if="result && result.success" class="pt-3">
        <v-card-title class="d-flex justify-center">
          <div class="result-title">{{ $t('payment.refund_payment_success') }} {{ result.qrPaymentReport.amount | currencySuffixTextThEn }}</div>
        </v-card-title>
        <v-card-text class="result-text">
          <div>{{ $t('when') }} {{ $moment(result.qrPaymentReport.voidedDate.iso).format("DD/MM/YYYY") }}, {{ $moment(result.qrPaymentReport.voidedDate.iso).format("H:mm") }} {{ $t('timeunit.minute.short') }}</div>
          <div>{{ $t('customer.operation_by') }} {{ fullName(result.qrPaymentReport.voidedBy) }}</div>
        </v-card-text>
        <v-card-actions class="d-flex justify-center border-t">
          <v-btn
            color="primary"
            @click="isResultDialog = false"
            width="180px"
            elevation="0"
          >
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-if="result && !result.success" class="pt-3">
        <v-card-title class="d-flex justify-center">
          <div class="result-title error--text">{{ $t('payment.refund_payment_failed') }}</div>
        </v-card-title>
        <v-card-text class="result-text">
          <div class="error--text" v-if="result.message && result.message.errorDesc_th">{{ result.message.errorDesc_th }}</div>
          <div class="error--text" v-else-if="result.message && result.message.errorDesc">{{ result.message.errorDesc }}</div>
          <div>{{ $t('when') }} {{ $moment(result.qrPaymentReport.voidedDate.iso).format("DD/MM/YYYY") }}, {{ $moment(result.qrPaymentReport.voidedDate.iso).format("H:mm") }} {{ $t('timeunit.minute.short') }}</div>
          <div>{{ $t('customer.operation_by') }} {{ fullName(result.qrPaymentReport.voidedBy) }}</div>
        </v-card-text>
        <v-card-actions class="d-flex justify-center border-t">
          <v-btn
            color="error"
            @click="isResultDialog = false"
            width="180px"
            elevation="0"
          >
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  props: {
    value: Boolean,
    qrPaymentReport: Object
  },
  data() {
    return {
      note: '',
      isLoading: false,
      isResultDialog: false,
      result: null
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.note = ''
      }
    }
  },
  methods: {
    dismiss() {
      this.$emit('input', false)
    },
    async confirmVoid() {
      this.isLoading = true
      try {
        this.result = await this.$store.dispatch("qrPayment/qrPaymentVoidWithCancelPayment", {
          id: this.qrPaymentReport.objectId,
          note: this.note
        })
        this.dismiss()
        this.$emit('onSuccess', true)
        this.isResultDialog = true
        this.isLoading = false
      } catch (error) {
        this.$toast.show({
          content: this.$t('error'),
          color: "error"
        });
        this.isResultDialog = true
        this.isLoading = false
      }
    },
    fullName(user) {
      return `${user.firstName || ""} ${user.lastName || ""}`
    }
  }
}
</script>

<style lang="scss" scoped>
.total-pay {
  font-size: 20px;
  font-weight: bold;
  color: var(--v-fontInfo-base);
  background-color: var(--v-bgInfo-base);
  padding: 12px 15px;
  border-radius: 6px;
}
.box-detail {
  border: 1px solid var(--v-bgPrimary-base);
  padding: 0px 15px;
  border-radius: 5px;
  font-size: 16px;
  color: black;
}
.detail-boder {
  border-bottom: 1px solid var(--v-bgPrimary-base);
}
.result-title {
  font-size: 20px;
  font-weight: bold;
  color: var(--v-success-base);
  display: flex;
  justify-content: center;
}
.result-text {
  font-size: 16px;
  text-align: center;
  margin-bottom: 20px;
  margin-top: 20px;
}
</style>